import { WireCampaignDetailsResponse } from 'scenes/common/api/campaign/types';

export const toPromoCode = (campaigns?: WireCampaignDetailsResponse[]) =>
  campaigns?.[0]?.promoCode ?? '';
